import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const StudentInfo = props => {
  return (
    <Fragment>
      <h3>Student Info</h3>
      <ul>
        <li>
          <b>User ID:</b> {props.log.params.user_id}
        </li>
        <li>
          <b>Roles:</b> {props.log.params.roles}
        </li>
      </ul>
    </Fragment>
  )
}
export default StudentInfo

StudentInfo.propTypes = {
  log: PropTypes.object,
}
